export function BBBSeal({ className = "" }: { className?: string }) {
  return (
    <a
      href="https://www.bbb.org/us/fl/beverly-hills/profile/roofing-contractors/destination-roofing-inc-0733-235982303/#sealclick"
      target="_blank"
      rel="nofollow"
      className={`inline-block ${className}`}
    >
      <img
        src="https://seal-centralflorida.bbb.org/seals/blue-seal-160-82-bbb-235982303.png"
        width={160}
        height={82}
        style={{ border: 0 }}
        alt="Destination Roofing Inc BBB Business Review"
      />
    </a>
  );
}
